export default __webpack_public_path__ + "static/media/dollar.edc4dbbe.jpeg";